






















import { Vue } from "../../constants/constants";
import { isRTL, isLoggedInUser, URLBuilder } from "../../helpers";
import { staticContent } from "../../localisation/detect-lang";

export default Vue.component("location-disclaimer", {
  props: [],

  data() {
    return {
      staticContent,
      URLBuilder,
      isRTL,
      isSkipped: false,
      isLoggedInUser,
    };
  },

  mounted() {},

  computed: {
    profile() {
      return this.$store.getters.getProfileData;
    },
    hasLocation() {
      return this.$root.user.location.long && this.$root.user.location.lat
        ? true
        : false;
    },

    currentLang() {
      return isRTL ? "ar" : "en";
    },
  },
  methods: {
    closeModal() {
      this.isSkipped = true;
    },
  },
});
